const formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'एक सेकेन्ड भन्दा कम',
    other: '{{count}} सेकेन्ड भन्दा कम',
  },

  xSeconds: {
    one: '१ सेकेन्ड',
    other: '{{count}} सेकेन्ड',
  },

  halfAMinute: 'pola minute',

  lessThanXMinutes: {
    one: 'एक मिनेट भन्दा कम',
    other: '{{count}} मिनेट भन्दा कम',
  },

  xMinutes: {
    one: '१ मिनेट',
    other: '{{count}} मिनेट',
  },

  aboutXHours: {
    one: 'करीव १ घण्टा',
    other: 'लगभग {{count}} घण्टा',
  },

  xHours: {
    one: '1 घण्टा',
    other: '{{count}} घण्टा',
  },

  xDays: {
    one: '१ दिन',
    other: '{{count}} दिन',
  },

  aboutXMonths: {
    one: 'करीव १ महिना',
    other: 'लगभग {{count}} महिनाहरू',
  },

  xMonths: {
    one: '1 महिना',
    other: '{{count}} महिना',
  },

  aboutXYears: {
    one: 'करीव १ बर्ष',
    other: 'लगभग {{count}} वर्षहरू',
  },

  xYears: {
    one: '1 वर्ष',
    other: '{{count}} वर्ष',
  },

  overXYears: {
    one: '१ बर्ष भन्दा बढी',
    other: '{{count}} over वर्ष भन्दा बढी',
  },

  almostXYears: {
    one: 'लगभग १ बर्ष',
    other: 'लगभग {{count}} वर्ष',
  },
};

export default function formatDistance(token, count, options) {
  options = options || {};

  let result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else if (count > 1 && count < 5) {
    result = formatDistanceLocale[token].few;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result;
    }

    return result + ' पहिले';
  }

  return result;
}
